import React, { useState } from "react";

function PennyDrop() {
  const [accNumber, setAccNumber] = useState("");
  const [ifsc_code, setifsc_code] = useState("");
  const [cardData , setCardData] = useState("")

  const handleSubmit = async (e) => {
    e.preventDefault();

    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "Crwf7Enu7B7fwC7XTeUO2J2gsUeqzoe2m3KoJoh2");
    myHeaders.append("authorizationToken", "1Jw2D9vo4O2Dsk55");
    myHeaders.append("client-secret-key", "LxGItknoRxdMbjD8AA2Fy1cG40jBSMwu");

    myHeaders.append("Content-Type", "text/plain");

    const raw = JSON.stringify({ acc_no: accNumber, ifsc_code,     "client_id" : "1234" });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    try {
      const response = await fetch("https://xnz0z0gpy4.execute-api.ap-south-1.amazonaws.com/default/ainxt_service_pennyless", requestOptions);
      const result = await response.json();
      console.log(result.bene_name);
      setCardData(result)
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
     <label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '10px' }}>
  Account Number:
  <input
    type="text"
    value={accNumber}
    onChange={(e) => setAccNumber(e.target.value)}
    style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '5px' }}
  />
</label>
<br />
<label style={{ display: 'block', fontSize: '16px', color: '#333', marginBottom: '10px' }}>
  IFSC:
  <input
    type="text"
    value={ifsc_code}
    onChange={(e) => setifsc_code(e.target.value)}
    style={{ padding: '5px', border: '1px solid #ccc', borderRadius: '5px' }}
  />
</label>

      <br />
      <table class="table">
            <tbody>
            <tr>
                <th> Status</th>
                <td>{cardData.status}</td>
                 </tr>
              <tr>
                <th width="25%">Beneficiary Name</th>
                <td>{cardData.bene_name} </td>
              </tr>
              <tr>
                <th> Reference_no</th>
                <td>{cardData.reference_no}</td>
              </tr>
              <tr>
                <th> client_id</th>
                <td>{cardData.client_id}</td>
              </tr>
              <tr>
                <th> Remark</th>
                <td>{cardData.remark}</td>
              </tr>
             
            </tbody>
          </table>
      <button onClick={handleSubmit}>Submit </button>
      
    </form>
  );
}

export default PennyDrop;